module.exports = __webpack_public_path__ + "img/amio_chat.4d2befff.svg";